import React, {Component} from 'react';
// helpers
import {getFootballMarketNameByCode} from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, VOIDED} from "../../../../../constants/identifiers";
import style from "../../../css/lockedBetFootball.css";
import {getGameTitle} from "../../../../../helpers/eventHelpers";
import {isSoccer3FootballEvent} from '../../../../../helpers/moduleHelpers';

class LockedBetFootball extends Component {

    _createEventDetails(eventDetails) {
        let noGoals = 'No goals';

        let firstTeamToScoreUI = '';
        if (eventDetails.firstTeamToScore !== '') {
            firstTeamToScoreUI = (<div className={`${style.eventDetailsLine}`}>
                <div className={style.eventDetailsLineLeft}>{getText('FIRST_TEAM_TO_SCORE', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{eventDetails.firstTeamToScore === noGoals ? getText('NO_GOALS', this.props.store) : getText(eventDetails.firstTeamToScore, this.props.store)}</div>
            </div>);
        }
        let lastTeamToScoreUI = '';
        if (eventDetails.lastTeamToScore !== '') {
            lastTeamToScoreUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('LAST_TEAM_TO_SCORE', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{eventDetails.lastTeamToScore === noGoals ? getText('NO_GOALS', this.props.store) : getText(eventDetails.lastTeamToScore, this.props.store)}</div>
            </div>);
        }

        return (
            <div>
                <div className={`${style.eventDetailsLine} ${style.even}`}>
                    <div className={style.eventDetailsLineLeft}>{getText('HALF_TIME_RESULT', this.props.store)}</div>
                    <div className={style.eventDetailsLineRight}>{eventDetails.halfTimeResult}</div>
                </div>
                {firstTeamToScoreUI}
                {lastTeamToScoreUI}
            </div>
        );
    }

    render() {

        let eventDetails;
        let bet = this.props.betSelection.Bets[0];

        let homeTeam = getText(bet.EventDetails.team1, this.props.store);
        let awayTeam = getText(bet.EventDetails.team2, this.props.store);
        let score = ' VS ';
        if(bet.EventDetails.fullTimeResult)
        {
            score = getText(bet.EventDetails.fullTimeResult, this.props.store);
        }    
        let voidStatus = bet.State === 'VOIDED';
        let title = `${homeTeam} ${score} ${awayTeam}`;
        let eventName = getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage);
        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);

        let betType = getText(getFootballMarketNameByCode(marketInfo.marketCode), this.props.store, [homeTeam, awayTeam]);
        let odd = bet.Market.Price;

        let name = '';
        if (marketInfo !== null) {
            name = isNaN(marketInfo.footballSelection)
                ? getText(marketInfo.footballSelection, this.props.store, [homeTeam, awayTeam])
                : marketInfo.footballSelection;
        }

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus && !isSoccer3FootballEvent(bet.EventType)) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        {this._createEventDetails(bet.EventDetails)}</div>

                </div>
            );
            eventName.score = homeTeam + " " + bet.EventDetails.fullTimeResult.split('').join(' ') + " " + awayTeam;
            eventName.formated = (<div className={style.footballTitle}>
                <div className={style.eventTime}>{`${eventName.dayMonthYear} `}{`${eventName.hoursMinutes} `}</div>
                <p className={style.resultContainer}>
                    {`${homeTeam} `}{` ${bet.EventDetails.fullTimeResult.split('').join(' ')} `}{` ${awayTeam}`}</p>

                {/*<div className={style.teamName}>{bet.EventDetails.team1}</div>*/}
                {/*<div className={style.result}>{bet.EventDetails.fullTimeResult.split('').join(' ')}</div>*/}
                {/*<div className={style.teamName}>{bet.EventDetails.team2}</div>*/}
            </div>);
        }

        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           betType={betType} odd={odd} eventName={eventName} names={[name]}
                           isSettledBet={this.props.isSettledBet} eventDetails={eventDetails}
                           voidStatus={voidStatus}/>);
    }
}

export default LockedBetFootball;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/lockedBetFootball.js